(() => {
  if (window.__tpDirectCartAnalyticsV3) return;
  window.__tpDirectCartAnalyticsV3 = true;

  const productKey = (text) => {
    const value = String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (value.includes('pellet')) return 'pellets';
    if (value.includes('nugget')) return 'nuggets';
    if (value.includes('scheib')) return 'scheiben';
    return value ? 'other' : undefined;
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;

    const button = target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"], button[name="add"], .add-to-cart-button');
    if (!button || button.closest('.prime-planner')) return;

    const scope = button.closest('product-form-component, .product-information, .product, main') || document;
    const title = scope.querySelector('h1, [data-product-title], .product__title')?.textContent || '';
    const tracker = window.TPAnalytics;
    if (!tracker?.track) return;

    tracker.track('tp_direct_cart_click', {
      tp_product: productKey(title),
      tp_entry_point: tracker.context?.tp_page_type || 'storefront'
    });
  }, false);
})();
